import api from 'api'
import { AxiosResponse } from 'axios'

export const downloadPrescricaoDigital = (codigoPrescricaoDigital: string): Promise<AxiosResponse> => {
  return api.prescricaoDigital.downloadPrescricaoDigital(codigoPrescricaoDigital)
}
